import { createAsyncSagaAction } from 'utils/reduxUtils';
import * as actionTypes from './actionTypes';

export const onUnmountNotificationList = fields => ({
  type: actionTypes.ON_UNMOUNT_NOTIFICATION_LIST,
  payload: fields,
});
export const onUnmountWeatherAlertList = fields => ({
  type: actionTypes.ON_UNMOUNT_WEATHER_ALERT_LIST,
  payload: fields,
});
export const onClearCache = fields => ({
  type: actionTypes.ON_CLEAR_CACHE,
  payload: fields,
});
export const getNotificationList = createAsyncSagaAction(actionTypes.GET_NOTIFICATION_LIST);
export const getNotification = createAsyncSagaAction(actionTypes.GET_NOTIFICATION);
export const getWeatherAlertList = createAsyncSagaAction(actionTypes.GET_WEATHER_ALERT_LIST);
export const getWeatherAlert = createAsyncSagaAction(actionTypes.GET_WEATHER_ALERT);

// const getEventList = () =>
//     Ajax.get(`/rest/event?orgId=${orgId}`)
// const getEvent = params =>
//     Ajax.get(`/rest/event/${params.eventId}?orgId=${orgId}`)
// const getEventNotifList = params =>
// Ajax.get(`/rest/event/${params.eventId}/notif?orgId=${orgId}&baseTime=${params.baseTime || ''}`)
// const getEventNotif = params =>
//     Ajax.get(`/rest/event/${params.eventId}/notif/${params.notificationId}?orgId=${orgId}`)
